export default __webpack_public_path__ + "static/media/CloseIcon.d8482ed5.svg";